var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hamburger",class:_vm.showMenu ? 'is-active': '',attrs:{"type":"button","id":"hamburger"},on:{"click":_vm.toggle}},[_c('span',{staticClass:"hamburger__item"})])}
var staticRenderFns = []

export { render, staticRenderFns }